// extracted by mini-css-extract-plugin
export default {"header":"CentreDetails_header__aKhH3"};